import React from 'react';
import ScheduledAgents from '../../../ScheduledAgents';

const SECTIONS = [
  {
    label: 'Scheduled Agents',
    value: 'scheduledAgents',
    component: <ScheduledAgents />
  }
];

export default SECTIONS;
